import React, { useState } from 'react';
import { PrimaryButton } from '@stax-core/truffle-components';
import styled from 'styled-components';
import { useToaster } from '../../hooks';
import { Group, Modal } from '..';

export const ExclamationIcon = styled.i`
  font-size: 70px;
  color: #bdc9cc;
  text-align: center;
  margin-top: 20px;
  display: block;
`;

export const WarningText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin: 10px auto 50px;
  text-align: center;
  color: #062333;
  max-width: 350px;
`;

export const AccountUnlinkModal = (props: {
  isOpen: boolean;
  maskedAccount: string;
  showModal: React.Dispatch<React.SetStateAction<boolean>>;
  removeAccount: () => Promise<boolean>;
}) => {
  const { isOpen, maskedAccount, showModal, removeAccount } = props;
  const { toaster, toast } = useToaster();
  const [isRemoving, setIsRemoving] = useState(false);

  const unlinkAccount = async () => {
    showModal(false);
    setIsRemoving(true);
    const success = await removeAccount();
    setIsRemoving(false);
    if (success) {
      toaster(toast.success('Account Successfully Unlinked'));
    } else {
      toaster(toast.error('There was a problem unlinking your account'));
    }
  };

  return (
    <Modal
      title={'Remove Linked Account'}
      isOpen={isOpen}
      onClose={() => {
        showModal(false);
      }}
      style={{ height: 'auto', paddingBottom: '20px' }}
    >
      <ExclamationIcon
        className={'fa fa-exclamation-triangle'}
      ></ExclamationIcon>
      <WarningText>
        Are you sure that you would like to remove linked account ending in{' '}
        {maskedAccount}?
      </WarningText>
      <Group direction={'row'} style={{ width: '210px', margin: '0 auto' }}>
        <PrimaryButton
          onClick={() => {
            showModal(false);
          }}
          style={{
            background: 'none',
            color: '#062333',
            border: '1px solid #062333',
            marginRight: '10px',
            outline: 'none',
          }}
          trackingId="plaid-unlink-cancel"
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton
          disabled={isRemoving}
          onClick={unlinkAccount}
          style={{
            background: '#E30029',
            color: '#FFFFFF',
            border: '1px solid #E30029',
            borderRadius: '2px',
          }}
          trackingId="plaid-unlink-remove"
        >
          {isRemoving ? 'Removing...' : 'Remove'}
        </PrimaryButton>
      </Group>
    </Modal>
  );
};
